import React from "react";
import FNum from "../../Utils/FormatNumber";

export default function ProbabilityTable(props) {
  const tableData = props.tableData;

  if (tableData === undefined) {
    return <></>;
  }

  return (
    <>
      <table>
        <tr>
          {/* <th>Percentile</th> */}
          <th>Amount</th>
          <th>Probability</th>
        </tr>
        {tableData.map((i) => {
          return (
            <tr key={i.percentile}>
              {/* <td>{i.percentile}%</td> */}
              <td>${FNum(i.amount)}</td>
              <td>{100 - i.percentile}% Chance</td>
            </tr>
          );
        })}
      </table>
    </>
  );
}
